import { typography } from '@dentalux/ui-library-core'
import { Theme } from '@mui/material/styles'
import { createUseStyles } from 'react-jss'
import { forPhoneOnly } from 'src/config/mediaQueries'
import { BUTTON_WIDTH } from 'src/config/styles'

export default createUseStyles((theme: Theme) => ({
  appointmentSummary: {
    margin: '0 auto',
    maxWidth: BUTTON_WIDTH,
    [forPhoneOnly]: {
      width: '100%',
      maxWidth: '100%',
    },
  },
  separatorLine: {
    height: 1,
    background: theme.palette.grey[300],
  },
  appointmentInfoOuterContainer: {
    padding: [16, 0],
    display: 'flex',
    justifyContent: 'center',
  },
  appointmentInfoInnerContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  practitioner: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 16,
  },
  practitionerImage: {
    width: 48,
    height: 48,
    borderRadius: '100%',
  },
  dataLabel: {
    flex: 1,
    width: 80,
    whiteSpace: 'nowrap',
    marginRight: 16,
    ...typography['Lato Emphasized 2'],
  },
  dataValue: {
    flex: 3,
    ...typography['Lato Body 2'],
  },
  practitionerImageContainer: {
    width: 80,
    marginRight: 16,
  },
  practitionerName: {
    ...typography['Lato Emphasized 2'],
  },
  appointmentData: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  dataContainer: {
    display: 'flex',
  },
  anaText: {
    ...typography['Lato H5'],
    textAlign: 'center',
    [forPhoneOnly]: {
      ...typography['Lato Body 1'],
    },
  },
  anaButtonContainer: {
    marginTop: 16,
    textAlign: 'center',
  },
  anaButton: {
    width: BUTTON_WIDTH,
    [forPhoneOnly]: {
      width: '100%',
    },
  },
}))
